<template>
    <div class="ml-auto mr-auto" style="max-width: 400px;">
        <form
            id="wfhSignInForm"
            @submit="submitForm"
        >
            <div class="mt-30">
                <label
                    for="email"
                    class="wfh-form-label"
                    :class="{'text-danger': emailError}"
                >
                    Email Address
                </label>
                <input
                    class="form-control wfh-input-box"
                    :class="{'is-invalid': emailError}"
                    style="background-image: none !important;"
                    type="email"
                    id="email"
                    v-model="companyState.user.email"
                    placeholder="josh@work.com"/>
                <span v-if="emailError" v-text="emailError" class="wfh-err-label"></span>
            </div>
            <div class="mt-30 position-relative">
                <label
                    for="password"
                    class="wfh-form-label"
                    :class="{'text-danger': passwordError}"
                >
                    Password
                </label>
                <input
                    ref="passwordField"
                    class="form-control wfh-input-box"
                    :class="{'is-invalid': passwordError}"
                    style="background-image: none !important;"
                    type="password"
                    id="password"
                    v-model="companyState.user.password"
                    placeholder="Minimum 8 characters"/>
                <button
                    class="btn btn-link position-absolute"
                    style="padding: 0 !important;top: 37px;right: 16px"
                    @click="togglePasswordView"
                >
                    <i class="fas"
                       style="color: #303030;"
                       :class="{'fa-eye': !viewPassword, 'fa-eye-slash': viewPassword}"
                    ></i>
                </button>
                <span v-if="passwordError" v-text="passwordError" class="wfh-err-label"></span>
            </div>

            <div class="mt-30">
                <label
                    for="company"
                    class="wfh-form-label"
                    :class="{'text-danger': companyError}"
                >
                    Company
                </label>
                <input
                    class="form-control wfh-input-box"
                    :class="{'is-invalid': companyError}"
                    style="background-image: none !important;"
                    type="text"
                    id="company"
                    v-model="companyState.company.name"/>
                <span v-if="companyError" v-text="companyError" class="wfh-err-label"></span>
            </div>

            <div class="mt-30">
                <label
                    for="designation"
                    class="wfh-form-label"
                    :class="{'text-danger': designationError}"
                >
                    Designation
                </label>
                <input
                    class="form-control wfh-input-box"
                    :class="{'is-invalid': designationError}"
                    style="background-image: none !important;"
                    type="text"
                    id="designation"
                    v-model="companyState.user.designation"/>
                <span v-if="designationError" v-text="designationError" class="wfh-err-label"></span>
            </div>

            <div class="text-center">
                <button
                    type="submit"
                    :disabled="!formCompleted || loading"
                    class="btn wfh-btn-primary position-relative"
                    style="margin-top: 30px;"
                >
                    <span
                        class="spinner-border position-absolute"
                        role="status"
                        style="left: 16px;top: 10px;"
                        v-show="loading"
                    >
                        <span class="sr-only">Loading...</span>
                    </span>
                    Sign-up
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: ['companyState'],

        data() {
            return {
                emailError: null,
                passwordError: null,
                companyError: null,
                designationError: null,
                viewPassword: false,
                loading: false
            }
        },

        computed: {
            formCompleted() {
                return (this.companyState.user.email &&
                    this.companyState.user.password &&
                    this.companyState.user.designation &&
                    this.companyState.company.name);
            }
        },

        methods: {
            async submitForm(e) {
                this.loading = true;
                e.preventDefault();
                this.resetValidation();

                if (await this.validateForm()) {
                    window.scrollTo(0, 0);
                    this.companyState.progress++;
                    document.querySelector("#get-started-tab").click();
                }

                this.loading = false;
            },

            togglePasswordView(e) {
                this.viewPassword = !this.viewPassword;
                this.$refs['passwordField'].type = this.viewPassword ? 'text' : 'password';
                e.preventDefault();
            },

            async validateForm() {
                const emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                let errCount = 0;

                if (this.companyState.user.password.length < 8) {
                    this.passwordError = 'Password is too short';
                    errCount++;
                }

                if (!emailReg.test(this.companyState.user.email)) {
                    this.emailError = 'Invalid email address please try again';
                    errCount++;
                }

              const res = await axios.get(`/company?name=${this.companyState.company.name}`);

              if (res.data.data.data.length > 0) {
                this.companyError = 'Your company already exist on the system. Please contact your admin to be added as a team member.';
                errCount++;
              }

                return errCount === 0;
            },

            resetValidation() {
                this.passwordError = null;
                this.emailError = null;
                this.companyError = null;
                this.designationError = null;
            }
        },

        mounted() {
            this.companyState.user.email = this.email;
        }
    }
</script>

<style lang="scss" scoped>
    .mt-30 {
        margin-top: 30px;
    }
</style>
